<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form (keypress)="ocultarMensagem()" #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="operacao">Operação</label>
                            <p-dropdown
                                [options]="operacoes"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Selecione"
                                name="operacao"
                                ngModel
                                #operacao="ngModel"
                                [(ngModel)]="tipoPagamento.operacao"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="bandeira">Bandeira</label>
                            <p-dropdown
                                [options]="bandeiras"
                                placeholder="Selecione"
                                name="bandeira"
                                ngModel
                                #bandeira="ngModel"
                                [(ngModel)]="tipoPagamento.bandeira"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="transacao">Transação</label>
                            <p-dropdown
                                [options]="transacoes"
                                placeholder="Selecione"
                                name="transacao"
                                ngModel
                                #transacao="ngModel"
                                [(ngModel)]="tipoPagamento.transacao"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label>Meio Pagamento</label>
                            <p-dropdown
                                [options]="meiosPagamento"
                                optionLabel="descricao"
                                placeholder="Selecione"
                                name="meioPagamentoTributario"
                                #meioPagamentoTributario="ngModel"
                                [(ngModel)]="tipoPagamento.meioPagamentoTributario"
                                [required]="true"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="antencipacao">Taxa de Antecipação</label>
                            <p-inputNumber
                                [(ngModel)]="tipoPagamento.antecipacao"
                                suffix="%"
                                name="antencipacao"
                                [max]="100"
                                mode="decimal"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                            ></p-inputNumber>
                        </div>
                    </div>
                    <div class="container card col-12">
                        <h5>Parcelas</h5>
                        <div class="components p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-3">
                                <label htmlFor="quantidadeParcelas">Insira a quantidade</label>
                                <input
                                    pInputText
                                    type="number"
                                    name="quantidadeParcelas"
                                    [(ngModel)]="qtdParcelas"
                                />
                            </div>
                            <div class="field col-12 md:col-2">
                                <button
                                    pButton
                                    pRipple
                                    label="Adicionar"
                                    class="p-button-success mt-5"
                                    icon="pi pi-check"
                                    (click)="gerarParcelas()"
                                    style="box-shadow: none"
                                    type="button"
                                ></button>
                            </div>
                        </div>

                        <p-table
                            #dt1
                            [value]="parcelas"
                            dataKey="id"
                            [rows]="10"
                            [rowHover]="true"
                            [paginator]="false"
                            responsiveLayout="scroll"
                            styleClass=" p-datatable-sm"
                        >
                            <ng-template pTemplate="header">
                                <tr *ngIf="parcelas.length > 0">
                                    <th>
                                        <div>Parcela</div>
                                    </th>
                                    <th>
                                        <div>Prazo</div>
                                    </th>
                                    <th>
                                        <div>Taxa Operadora</div>
                                    </th>
                                    <th>
                                        <div>Excluir</div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-parcela let-i="rowIndex">
                                <tr>
                                    <td>
                                        {{ parcela.quantidadeParcelas }}
                                    </td>
                                    <td>
                                        <input
                                            class="p-inputtext"
                                            type="number"
                                            pInputText
                                            name="prazo{{ parcela.quantidadeParcelas }}"
                                            [(ngModel)]="parcela.prazo"
                                        />
                                    </td>
                                    <td>
                                        <p-inputNumber
                                            [(ngModel)]="parcela.descontoFinanceira"
                                            suffix="%"
                                            name="desconto{{ parcela.id }}"
                                            [max]="100"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                        ></p-inputNumber>
                                    </td>
                                    <td>
                                        <button
                                            pButton
                                            pRipple
                                            pTooltip="Excluir"
                                            type="button"
                                            icon="pi pi-trash"
                                            class="p-button-danger mt-5"
                                            (click)="excluirParcela(parcela)"
                                            [disabled]="i !== parcelas.length - 1"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7">Nenhum registro cadastrado.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="field col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Salvar"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!f.valid"
                                (click)="salvar()"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="button"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Salvar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="field col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/tipo-pagamento"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
